@if (emailNotificationShown()) {
    <div class="alert" [@alertAnimation]>
        <div class="icon">
            <mat-icon svgIcon="ico_checkmark_filled"></mat-icon>
        </div>

        <div class="alert__content">
            <p class="subheading-1">
                Your email address has been updated. Order and shipping details will be sent to the new one.
            </p>
            <p class="body-1">The email address in your primary profile remains unchanged.</p>
        </div>

        <button class="alert__close" aria-label="Close" type="button" (click)="closeEmailNotification()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
}
<div class="checkout-shipping-info">
    @if (isUserLoaded()) {
        <div class="checkout-shipping-info__section">
            <div class="checkout-shipping-info__row">
                <p class="subheading-1 address-title">Name</p>
                <p class="body-0">{{ firstName() | appCapitalFirstLetter }} {{ lastName() | appCapitalFirstLetter }}</p>
            </div>

            <div class="checkout-shipping-info__row checkout-shipping-info__row--form">
                <h3 class="subheading-1 address-title address-title-wrap">
                    Shipping address
                    <mat-icon
                        #tooltip1="matTooltip"
                        matTooltipPosition="right"
                        matTooltipTouchGestures="on"
                        svgIcon="ico_info"
                        tabindex="0"
                        [ariaLabel]="addressTooltip"
                        [attr.aria-hidden]="false"
                        [matTooltip]="addressTooltip"
                        (click)="tooltip1.toggle()"
                    />
                </h3>
                <lib-address-form idPrefix="shipping" [form]="addressForm" />
            </div>

            <div class="checkout-shipping-info__row">
                <p class="subheading-1 no-wrap address-title">Email</p>
                @if (!isEditEmail()) {
                    <div class="email-section">
                        <span class="body-0">{{ emailValue() }}</span>
                        <div class="action">
                            <button mat-button class="edit-email-btn" type="button" (click)="editEmail()">Edit</button>
                        </div>
                    </div>
                } @else {
                    <div class="edit-email-section">
                        <mat-form-field appearance="outline">
                            <input
                                #emailInput="ngModel"
                                aria-controls="email"
                                aria-live="polite"
                                autofocus
                                email
                                matInput
                                name="email"
                                required
                                role="searchbox"
                                type="email"
                                [(ngModel)]="emailValue"
                            />
                            @if (emailInput.errors?.['required']) {
                                <mat-error class="error-email" aria-live="assertive" role="alert">
                                    <mat-icon class="error-icon-color" svgIcon="ico_alert"></mat-icon>
                                    Email is required
                                </mat-error>
                            } @else if (emailInput.errors?.['email']) {
                                <mat-error class="error-email" aria-live="assertive" role="alert">
                                    <mat-icon class="error-icon-color" svgIcon="ico_alert"></mat-icon>
                                    Tell us a valid email address using '@' and a valid extension (for example: .com,
                                    .net, etc.).
                                </mat-error>
                            }
                        </mat-form-field>
                        <div class="edit-email-actions">
                            <button mat-button type="button" (click)="cancelEmail()">Cancel</button>
                            <button
                                mat-stroked-button
                                type="button"
                                [disabled]="emailInput.invalid"
                                (click)="saveEmail()"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
        <div class="divider"></div>
    } @else {
        <div class="checkout-shipping-info__section--skeleton">
            <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
        </div>
    }
    <div class="checkout-shipping-info__section">
        <div class="checkout-shipping-info__row">
            <p class="subheading-1 no-wrap address-title">Shipping method</p>
            <p class="body-0">Free</p>
        </div>
    </div>
    <div class="divider"></div>
    <div class="shipping-info">
        <p class="body-0">
            Shipments cannot be delivered to P.O. box addresses, United States territories or addresses outside of the
            United States. All order details and shipments will be sent to the shipping information above.
        </p>
    </div>

    <div class="action-buttons">
        <button
            mat-raised-button
            class="proceed-to-payment-btn"
            [disabled]="isContinueDisabled()"
            (click)="onContinue()"
        >
            Continue to payment
        </button>
    </div>
</div>
